import { ChangeEvent, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import "./main.scss";
import { CustomCheckBox, CustomSelect, CustomTable } from "../../../shared/uiComponents";
import { Container } from "../../SOAPNotes/Admin/helpers";
import { ClinicalSupervisorHeaders, Headers, TableBody } from "./tableInfo";
import SoapNotesHeader from "../soapNotesHeader";
import Filters from "./filters";

import { DispatchProperties, useSelector } from "../../../redux/store";
import { getSoapNotesUser } from "../../../redux/State/clientSlice/soapNoteSlice";
import { AdminTypes } from "../../../components/Menu";
import { SelectChangeEvent } from "@mui/material";

const sessionTypesBCBA = [
  { id: "1", name: "97151 - Assessment" },
  { id: "2", name: "97151 or H0032 - Treatment Planning" },
  { id: "4", name: "97155 - Direct Supervision" },
  { id: "5", name: "97155 - Behavior Treatment Modification" },
  { id: "6", name: "97156 - Parent Training" },
  { id: "", name: "All" },
];

const sessionTypesBT = [
  { id: "3", name: "97153 - Behavior Treatment" },
  { id: "7", name: "Meet & Greet - 97153" },
  { id: "8", name: "Meet & Greet - Non-Billable" },
  { id: "", name: "All" },
];

const UserSoapNotes = () => {
  const dispatch = useDispatch<DispatchProperties>();

  const [params, setParams] = useSearchParams();

  const includeBtSessions = params.get("includeBtSessions") === "false" ? false : true;
  const page = params.get("page") || "1";
  const pageSize = params.get("pageSize") || "8";
  const direction = params.get("direction") || "";
  const orderBy = params.get("orderBy") || "";
  const status = params.get("status") || "";
  const searchString = params.get("search") || "";
  const sessionType = params.get("sessionType") || "";

  const soapNotes = useSelector((state) => state.soapNote.soapNotes);
  const role = useSelector((state) => state.account.role);

  const isBT = role?.section.id === AdminTypes.bt;

  const loading = useSelector((state) => state.soapNote.loading);
  const filterData = useSelector((state) => state.billing.billingFilters);
  const userId = useSelector((state) => state.account.user.id);

  useEffect(() => {
    if (!userId) return;
    const { startDate, endDate, clientId } = filterData;
    const btId = filterData.userId;

    if (!startDate || !endDate) return;
    dispatch(
      getSoapNotesUser({
        userId: !!btId ? btId : userId,
        clientId,
        page,
        pageSize,
        direction,
        orderBy,
        searchString,
        status,
        startDate,
        endDate,
        includeBtSessions,
        sessionType,
      })
    );
  }, [
    page,
    pageSize,
    direction,
    orderBy,
    searchString,
    status,
    includeBtSessions,
    userId,
    filterData,
    sessionType,
    dispatch,
  ]);

  const includeBtSessionsHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    params.set("includeBtSessions", `${checked}`);
    setParams(params);
  };

  const sessionTypeHandler = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    params.set("sessionType", value);
    setParams(params);
  };

  const headers = role?.section.id === AdminTypes.cs ? ClinicalSupervisorHeaders : Headers;

  const sessionTypes = isBT ? sessionTypesBT : sessionTypesBCBA;

  return (
    <Container>
      <SoapNotesHeader />
      <div style={{ display: "flex", gap: 16, marginBottom: "16px" }}>
        <Filters />
      </div>
      <div style={{ display: "flex", gap: 16, marginBottom: "16px" }}>
        {!isBT && (
          <CustomCheckBox
            item={{
              id: "0",
              checked: includeBtSessions,
              label: "Include BT Sessions",
            }}
            onChange={includeBtSessionsHandler}
            style={{ marginTop: "24px" }}
          />
        )}
        <div style={{ width: "250px" }}>
          <CustomSelect
            data={sessionTypes}
            value={sessionType}
            setValue={sessionTypeHandler}
            label="Session Type"
          />
        </div>
      </div>
      <CustomTable headers={headers} data={soapNotes} TableBody={TableBody} loading={loading} />
    </Container>
  );
};

export default UserSoapNotes;
